module.exports = __webpack_public_path__ + "footer-logo-next.png?15136a9e9c28fed8a19b775f427b2bad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-next.png
// module id = 33
// module chunks = 0